import React from 'react';
import { bookingShape } from 'constants/propTypes';
import { withRouter } from 'react-router-dom';

import { withBooking } from 'components/queries/GetBookingQuery';
import HotelCompensation from './HotelCompensation';
import BOOKING_QUERY from './graphql/booking';
import { refundablePayments } from './HotelCompensation.utils';

const Index = ({ booking }) => {
  const { reference, payments, customer, passengers, hotels } = booking;

  const hotelToCompensate = hotels.find((h) => !h.cancelled && !h.provisional);
  const refundableBookingPayments = refundablePayments(payments);

  const handleSubmit = () => {
    // add compensation logic
  };

  const loading = false; // set to true when processing compensation

  return (
    <HotelCompensation
      reference={reference}
      hotel={hotelToCompensate}
      payments={refundableBookingPayments}
      loading={loading}
      onSubmit={handleSubmit}
      passengers={passengers}
      customer={customer}
    />
  );
};

Index.propTypes = {
  booking: bookingShape
};

export default withRouter(withBooking(Index, BOOKING_QUERY));
